// extracted by mini-css-extract-plugin
export default {"wrapperWithdrawForms":"WithdrawSkelet_wrapperWithdrawForms__Nebxt"};